import { Component, OnInit } from '@angular/core'; 
import { Proper } from '../../../../objects';
import { ApiService } from 'app/services/api.service';
import { MatDialogRef } from '@angular/material/dialog';
 
@Component({
  selector: 'app-proper-edit',
  templateUrl: './proper-edit.component.html',
  styleUrls: ['./proper-edit.component.css']
})
export class ProperEditComponent implements OnInit {

  public proper: Proper

  constructor(
    private dialog: MatDialogRef<ProperEditComponent>,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {
  }
  
  public loadProper(proper: Proper) {
    console.log("loadProper", proper);
    this.proper = proper;
  }

  public save(isProofed: boolean) {
    console.log("save", isProofed);

    var payload = {
      ProperId: this.proper.Id, 
      IsProofed: isProofed
    };
 
    this.apiSvc.post("api/Proper/save", payload).subscribe(
      (data: Proper[]) => {   
        this.dialog.close(true);
      },
      (err) => {
        alert("Error while saving the Proper");
        console.log("error", err); 
      }
   );

  }

  public cancel() {
    this.dialog.close();
  }

}
